import { ProfilePage } from "../../profile";

export default function ClientProfilePage(){
     return <ProfilePage></ProfilePage>
}